// extracted by mini-css-extract-plugin
export var popoverMenu = "PopoverMenu-module--popoverMenu--YsNED";
export var popoverMenu__popupContainer = "PopoverMenu-module--popoverMenu__popupContainer--GF3To";
export var popoverMenu__popup = "PopoverMenu-module--popoverMenu__popup--kft8T";
export var popoverMenuItem = "PopoverMenu-module--popoverMenuItem--MMFEo";